const tr = {
    translation: {
        "% Of times": "% Zamanında",
        "Accounts Manager": "Hesap Yöneticisi",
        "Action": "Eylem",
        "Actions": "Eylemler",
        "Active": "Aktif",
        "Active Campaigns": "Aktif Kampanyalar",
        "Add New Account": "Yeni Hesap Ekle",
        "Add Task": "Görev Ekle",
        "Add new": "Yeni Ekle",
        "Add the new URL": "Yeni URL Ekle",
        "Add the new keyword": "Yeni Anahtar Kelime Ekle",
        "Add the new tag": "Yeni Etiket Ekle",
        "Advance Options": "Gelişmiş Seçenekler",
        "Advance Setting": "Gelişmiş Ayar",
        "Advanced Clicking": "Gelişmiş Tıklama",
        "Advanced Functions": "Gelişmiş Fonksiyonlar",
        "Advanced Image Editor": "Gelişmiş Resim Düzenleyici",
        "All": "Tümü",
        "All settings": "Tüm Ayarlar",
        "An unexpected error has occurred": "Beklenmeyen bir hata oluştu",
        "Are you sure to clear all caches?": "Tüm önbelleği temizlemek istediğinizden emin misiniz?",
        "Are you sure to clear the accounts list?": "Hesap listesini temizlemek istediğinizden emin misiniz?",
        "Are you sure to clone this campaign?": "Bu kampanyayı klonlamak istediğinizden emin misiniz?",
        "Are you sure to delete this campaign?": "Bu kampanyayı silmek istediğinizden emin misiniz?",
        "Are you sure to delete this thread?": "Bu konuyu silmek istediğinizden emin misiniz?",
        "Are you sure to remove the campaign(s)?": "Kampanya(ları)ı kaldırmak istediğinizden emin misiniz?",
        "Are you sure to remove the proxies?": "Proxy'leri kaldırmak istediğinizden emin misiniz?",
        "Are you sure to reset settings?": "Ayarları sıfırlamak istediğinizden emin misiniz?",
        "Are you sure to restart the campaign(s)?": "Kampanya(ları)ı yeniden başlatmak istediğinizden emin misiniz?",
        "Are you sure to these changes?": "Bu değişiklikleri yapmak istediğinizden emin misiniz?",
        "Attribute": "Özellik",
        "Available days": "Kullanılabilir günler",
        "Avg Daily Visitors": "Ortalama Günlük Ziyaretçi",
        "Avg Visitor Duration": "Ortalama Ziyaretçi Süresi",
        "Back": "Geri",
        "Back To Campaigns": "Kampanyalara Geri Dön",
        "Block Images": "Resimleri Engelle",
        "Block Resources": "Kaynakları Engelle",
        "Block the campaign until VPN gets connected": "VPN bağlandığında kampanyayı engelle",
        "Browse Result Pages": "Sonuç Sayfalarına Göz At",
        "Browser Profile": "Tarayıcı Profili",
        "Browser Type": "Tarayıcı Türü",
        "Buy a license key": "Bir lisans anahtarı satın al",
        "CTR": "CTR",
        "CType": "CType",
        "Cache cleared successfully": "Önbellek başarıyla temizlendi",
        "Calendar": "Takvim",
        "Camp Settings": "Kamp Ayarları",
        "Campaign name": "Kampanya adı",
        "Campaign to clone": "Klonlamak için kampanya",
        "Campaigns": "Kampanyalar",
        "Chance": "Şans",
        "Change point": "Noktayı değiştir",
        "Changed successfully": "Başarıyla değiştirildi",
        "Choose": "Seç",
        "Choose an action": "Bir eylem seç",
        "Choose file": "Dosya seç",
        "Choose the file to import": "İçe aktarılacak dosyayı seç",
        "Clear": "Temizle",
        "Clear List": "Listeyi Temizle",
        "Clear all caches": "Tüm önbelleği temizle",
        "Click Here": "Buraya Tıkla",
        "Click on the map and move the pointer": "Haritada tıkla ve işaretçiyi hareket ettir",
        "Clicking Chance (CTR)": "Tıklama Şansı (CTR)",
        "Clone": "Klonla",
        "Clone Selected": "Seçileni Klonla",
        "Complete": "Tamamla",
        "Congratulations": "Tebrikler",
        "Connect your device to your computer/laptop via USB": "Cihazınızı USB aracılığıyla bilgisayarınıza/dizüstü bilgisayarınıza bağlayın",
        "Connection Type": "Bağlantı Türü",
        "Copyright DalgaDev": "Telif Hakkı DalgaDev",
        "Country": "Ülke",
        "Create new Campaign": "Yeni Kampanya Oluştur",
        "Created Campaigns": "Oluşturulan Kampanyalar",
        "Creation Date": "Oluşturulma Tarihi",
        "Custom CSS Selector (it will ignore the settings made above)": "Özel CSS Seçici (yukarıda yapılan ayarları yok sayacak)",
        "Custom Xpath Selector (it will ignore the settings made above)": "Özel Xpath Seçici (yukarıda yapılan ayarları yok sayacak)",
        "Dashboard": "Kontrol Paneli",
        "Dear User": "Sayın Kullanıcı",
        "Debug Logs": "Hata Ayıklama Kayıtları",
        "Delay Between": "Arasındaki Gecikme",
        "Delay between campaigns": "Kampanyalar arasındaki gecikme",
        "Delay on the main webpage": "Ana web sayfasındaki gecikme",
        "Description about latest camps and more …": "En son kamplar ve daha fazlası hakkında açıklama...",
        "Desktop": "Masaüstü",
        "Device Name": "Cihaz Adı",
        "Devices": "Cihazlar",
        "Direct Traffic": "Doğrudan Trafik",
        "Do you want the accounts of this profile to be replaced by the following accounts?": "Bu profilin hesaplarının aşağıdaki hesaplarla değiştirilmesini istiyor musunuz?",
        "Do you want to save the accounts on the selected profile before closing the window?": "Pencereyi kapatmadan önce seçilen profildeki hesapları kaydetmek istiyor musunuz?",
        "Don't block in these urls": "Bu URL'lerde engelleme yapma",
        "Edit": "Düzenle",
        "Edit Image": "Resmi Düzenle",
        "Edit Selected": "Seçileni Düzenle",
        "Edit Task": "Görevi Düzenle",
        "Edit in bulk": "Toplu düzenle",
        "Element": "Eleman",
        "Email": "E-posta",
        "Enter RSS feed URL here": "RSS besleme URL'sini buraya girin",
        "Enter Sitemap URL here": "Site haritası URL'sini buraya girin",
        "Enter group name": "Grup adını girin",
        "Enter the URL to import": "İçe aktarılacak URL'yi girin",
        "Enter the port": "Bağlantı noktasını girin",
        "Enter your license key": "Lisans anahtarınızı girin",
        "Error": "Hata",
        "Explore key details about your most recent campaigns": "En son kampanyalarınız hakkında önemli detayları keşfedin",
        "Export": "Dışa Aktar",
        "External links": "Harici bağlantılar",
        "Fast": "Hızlı",
        "Features & Actions": "Özellikler ve Eylemler",
        "Fix Error": "Hata Düzelt",
        "From": "Kimden",
        "Full debugging mode": "Tam hata ayıklama modu",
        "GO BACK": "GERİ DÖN",
        "GPS Simulation": "GPS Simülasyonu",
        "Generate Selectors Automatically": "Seçicileri Otomatik Oluştur",
        "Go to Campaigns": "Kampanyalara Git",
        "Google Account": "Google Hesabı",
        "Google Map": "Google Haritası",
        "How many pages should the bot visit in each session?": "Her oturumda bot kaç sayfayı ziyaret etmeli?",
        "How many seconds should IP visit other subpage?": "IP'nin diğer alt sayfayı kaç saniyede bir ziyaret etmesi gerekiyor?",
        "How would you like threads to operate?": "İpliklerin nasıl çalışmasını istersiniz?",
        "I accept the agreement": "Anlaşmayı kabul ediyorum",
        "If a configuration file doesn't work skip it and try another file": "Bir yapılandırma dosyası çalışmazsa atlayın ve başka bir dosyayı deneyin",
        "Import": "İçe Aktar",
        "Import (Seperate by line)": "İçe Aktar (Satır ile Ayır)",
        "Import From File": "Dosyadan İçe Aktar",
        "Import Options": "İçe Aktarma Seçenekleri",
        "Import Proxy": "Proxy İçe Aktar",
        "Import selected": "Seçilenleri İçe Aktar",
        "Import the websites in bulk (Seperate by line)": "Websitelerini toplu halde içe aktar (Satır ile Ayır)",
        "Imported successfully": "Başarıyla İçe Aktarıldı",
        "Inactive": "Pasif",
        "Input your text": "Metninizi girin",
        "Internal links": "Dahili bağlantılar",
        "Keyword": "Anahtar Kelime",
        "Keywords": "Anahtar Kelimeler",
        "Lan": "Lan",
        "Last Status": "Son Durum",
        "Latest Campaigns": "En Son Kampanyalar",
        "Learn More": "Daha Fazla Bilgi Edinin",
        "Less": "Daha Az",
        "License": "Lisans",
        "License Key": "Lisans Anahtarı",
        "Link": "Bağlantı",
        "Load File": "Dosyayı Yükle",
        "Load URL": "URL'yi Yükle",
        "Log all activities": "Tüm etkinlikleri kaydet",
        "Logout": "Çıkış Yap",
        "Make sure at least one task is added": "En az bir görev eklenmiş olduğundan emin olun",
        "Manage Account": "Hesabı Yönet",
        "Message": "Mesaj",
        "Mobile": "Mobil",
        "Mode": "Mod",
        "Modify": "Düzenle",
        "More": "Daha Fazla",
        "Multi Thread": "Çoklu İplik",
        "Multi Threading": "Çoklu İplik",
        "Name": "Ad",
        "Name Of Business": "İşletme Adı",
        "Never show notification at top": "Asla bildirimi en üstte gösterme",
        "New Task": "Yeni Görev",
        "Newest": "En Yeni",
        "No Keyword/websites were found to import": "İçe aktarılacak anahtar kelime/web sitesi bulunamadı",
        "No file chosen": "Hiçbir dosya seçilmedi",
        "No notification found": "Bildirim bulunamadı",
        "No thread found": "Hiç konu bulunamadı",
        "NordVPN": "NordVPN",
        "Notifications": "Bildirimler",
        "Number of visitors": "Ziyaretçi Sayısı",
        "OR": "YA DA",
        "Oldest": "En Eski",
        "OpenVPN files directory": "OpenVPN dosya dizini",
        "Order By": "Sırala",
        "Other VPN (Manual)": "Diğer VPN (Manuel)",
        "Overview": "Genel Bakış",
        "Overwrite": "Üzerine Yaz",
        "Pages": "Sayfalar",
        "Password": "Şifre",
        "Please accept the agreement": "Lütfen anlaşmayı kabul edin",
        "Please choose the mode you want to use": "Lütfen kullanmak istediğiniz modu seçin",
        "Please fill the format and protocol": "Lütfen format ve protokolü doldurun",
        "Point set successfully!": "Başarıyla nokta belirlendi!",
        "Port": "Bağlantı noktası",
        "Previous Step": "Önceki Adım",
        "Profiles": "Profiller",
        "Protocol": "Protokol",
        "Proxy": "Vekil Sunucu",
        "Put the app in windows start up": "Uygulamayı Windows başlangıcına ekleyin",
        "Quick Update": "Hızlı Güncelleme",
        "Reactive the bot with another purchase code": "Bot'u başka bir satın alma kodu ile etkinleştirin",
        "Recent logs": "Son Günlükler",
        "Recovery Email": "Kurtarma E-postası",
        "Remove": "Kaldır",
        "Remove All": "Hepsini Kaldır",
        "Remove Group": "Grubu Kaldır",
        "Remove Selected": "Seçilenleri Kaldır",
        "Remove non-functional proxies": "Çalışmayan proxy'leri kaldır",
        "Remove this device from the license key": "Bu cihazı lisans anahtarından kaldır",
        "Report": "Rapor",
        "Reset and clear all campaigns and their settings": "Tüm kampanyaları ve ayarlarını sıfırla ve temizle",
        "Restart": "Yeniden Başlat",
        "Restart All": "Hepsini Yeniden Başlat",
        "Restart Selected": "Seçilenleri Yeniden Başlat",
        "SE": "Arama Motoru",
        "Save": "Kaydet",
        "Save Profile": "Profili Kaydet",
        "Saved successfully": "Başarıyla kaydedildi",
        "Schedule": "Zamanlama",
        "Scheduled Camp": "Zamanlanmış Kampanya",
        "Scroll": "Kaydır",
        "Search": "Ara",
        "Search Engine": "Arama Motoru",
        "Search Engine Domain": "Arama Motoru Etki Alanı",
        "Search Language": "Arama Dil",
        "Seconds": "Saniyeler",
        "See All Notifications": "Tüm Bildirimleri Gör",
        "Select Airplane mode icon": "Uçak modu simgesini seçin",
        "Select Airplane mode icon on ATB": "ATB'de uçak modu simgesini seçin",
        "Select Campaign": "Kampanya Seç",
        "Select Edit Mode": "Düzenleme Modunu Seç",
        "Select Profile Name": "Profil Adını Seç",
        "Select a profile or enter a new profile name": "Bir profil seçin veya yeni bir profil adı girin",
        "Select from": "Şuradan Seç",
        "Select or enter a new profile": "Bir profil seçin veya yeni bir profil adı girin",
        "Select the website that you want visitors to be referred from": "Ziyaretçilerin yönlendirilmesini istediğiniz web sitesini seçin",
        "Sent Visitors": "Gönderilen Ziyaretçiler",
        "Sent views": "Gönderilen Görüntüler",
        "Session": "Oturum",
        "Settings": "Ayarlar",
        "Settings reset successfully": "Ayarlar başarıyla sıfırlandı",
        "Slow": "Yavaş",
        "Social Media": "Sosyal Medya",
        "Sorry, page not found!": "Üzgünüz, sayfa bulunamadı!",
        "Speed": "Hız",
        "Start": "Başlat",
        "Start All": "Hepsini Başlat",
        "Start Minimized": "Küçültülmüş olarak başlat",
        "Start Selected": "Seçilenleri Başlat",
        "Start sending traffic as soon as the app comes up": "Uygulama başladığında hemen trafiği göndermeye başla",
        "Statistics": "İstatistikler",
        "Status": "Durum",
        "Stop": "Durdur",
        "Stop All": "Hepsini Durdur",
        "Stop Selected": "Seçilenleri Durdur",
        "Submit": "Gönder",
        "Tablet": "Tablet",
        "Tags": "Etiketler",
        "Task Not Found": "Görev Bulunamadı",
        "Tasks": "Görevler",
        "Test Proxy": "Proxy'yi Test Et",
        "Test Proxy Result": "Proxy Test Sonucu",
        "The action was successfully done": "İşlem başarıyla tamamlandı",
        "The bot was deactivated": "Bot devre dışı bırakıldı",
        "The campaign cloned successfully": "Kampanya başarıyla kopyalandı",
        "The campaign has been modified": {
            " Click to save the changes": " Değişiklikleri kaydetmek için tıklayın"
        },
        "The campaign(s) removed successfully": "Kampanya(lar) başarıyla kaldırıldı",
        "The campaign(s) restarted successfully": "Kampanya(lar) başarıyla yeniden başlatıldı",
        "The campaign(s) started successfully": "Kampanya(lar) başarıyla başlatıld",
        "For instance: if you have 30 campaigns to send traffic to and you choose 30 threads,": "Örneğin: Eğer 30 kampanyanızı trafiğe göndermek istiyorsanız ve 30 adet çizgi seçerseniz,",
        "each thread will initiate from the first campaign and it will process campaigns until the last one.": "her çizgi ilk kampanyadan başlatılır ve son kampanyaya kadar işlemler gerçekleştirir.",
        "each thread will have a different campaign assigned (first thread will send traffic to the first campaign,": "her çizgi farklı bir kampanya atanmış olacak (ilk çizgi trafiği ilk kampanyaya gönderecek,",
        "second thread to the second campaign, and so forth)": "ikinci çizgi ikinci kampanyaya, ve böyle devam eder)",
        "Visit": "Ziyaret",
        "referrer": "referer",
        "Update Camp": "Kampanyayı Güncelle",
        "In Order": "Sırasıyla",
        "Randomised": "Rastgele",
        "try to play online videos": "çevrimiçi videoları oynamaya çalış",
        "if Url": "eğer URL",
        "Click": "Tıkla",
        "Equal": "Eşit",
        "Contain": "İçerir",
        "Then": "Sonra",
        "Inject JS": "JS Enjekte Et",
        "Total Visitors": "Toplam Ziyaretçi",
        "Inject Cookie": "Çerez Enjekte Et",
        "Logs": "Kayıtlar",
        "Threads": "Konular",
        "Help": "Yardım",
        "About": "Hakkında",
        "Type": "Tür",
        "Not Found": "Bulunamadı",
        "Search Engine Traffic": "Arama Motoru Trafik",
        "URL": "URL",
        "What do you want to export?": "Ne İhraç Etmek İstiyorsunuz?",
        "Sleeping": "Uyuyan",
        "Visitor": "Ziyaretçi",
        "Assign all campaigns to all of threads. Threads will start sending visitor from the first campaign all together.": "Tüm kampanyaları tüm konulara atayın. Konular, ziyaretçiyi ilk kampanyadan bir araya getirmeye başlayacak.",
        "Assign different campaigns to threads. Threads will start sending visitors from different campaigns.": "Farklı kampanyaları konulara atayın. Konular, farklı kampanyalardan ziyaretçi göndermeye başlayacak.",
        "This field must be filled in!": "Bu alan doldurulmalıdır!",
        "Update Campaign": "Kampanyayı Güncelle",
        "What we should call your campaign and more …": "Kampanyanızı nasıl adlandırmalıyız ve daha fazlası...",
        "User-agent Device Percentage": "Kullanıcı Aracı Cihaz Yüzdesi",
        "Video and Audio": "Video ve Ses",
        "Unlimited": "Sınırsız",
        "To": "İçin",
        "Image": "Resim",
        "CSS (Stylesheet)": "CSS (Stil Sayfası)",
        "Font": "Yazı Tipi",
        "Script (js codes)": "Script (js kodları)",
        "What to do?": "Ne yapmalı?",
        "What to do with browser directories?": "Tarayıcı dizinleriyle ne yapmalı?",
        "If you want to re-use the profiles later. you'll need to save the browser profiles": "Daha sonra profilleri tekrar kullanmak istiyorsanız, tarayıcı profillerini kaydetmelisiniz",
        "Next Step": "Sonraki Adım",
        "Your campaign is updated successfully": "Kampanyanız başarıyla güncellendi",
        "Start Type": "Başlangıç Türü",
        "Specific Date": "Belirli Tarih",
        "Day Of week": "Haftanın Günü",
        "Every day": "Her Gün",
        "Start Date": "Başlangıç Tarihi",
        "Start Time": "Başlangıç Saati",
        "End Type": "Bitiş Türü",
        "End Date": "Bitiş Tarihi",
        "End Time": "Bitiş Saati",
        "Default Settings": "Varsayılan Ayarlar",
        "Custom Settings": "Özel Ayarlar",
        "Create new profiles": "Yeni profiller oluştur",
        "Use previous profiles": "Önceki profilleri kullan",
        "Campaigns overview": "Kampanyalar Genel Bakış",
        "You should enable logging all activities to get detailed reports.": "Ayrıntılı raporlar almak için tüm etkinlikleri kaydetmeyi etkinleştirmelisiniz.",
        "Visitor(s)": "Ziyaretçi(ler)",
        "no directory chosen": "hiçbir dizin seçilmedi",
        "You need to download openvpn files (configs) from your VPN's website and place the config files into a directory and select it by the ATB": "VPN'nizin web sitesinden openvpn dosyalarını (config) indirmeniz ve yapılandırma dosyalarını bir dizine yerleştirmeniz ve ardından ATB tarafından seçmeniz gerekiyor",
        "Username": "Kullanıcı Adı",
        "Please follow these steps to configure your android phone to use it with the bot:": "Lütfen android telefonunuzu bot ile kullanmak için yapılandırmak için bu adımları takip edin:",
        "Turn On USB Debugging ( and USB Security Debugging on Xiaomi Phones ).": "USB Hata Ayıklamayı Açın (Xiaomi Telefonlarda USB Güvenlik Hata Ayıklamayı da Açın).",
        "Accept Authorization Request on your mobile. ( Select Always Checkbox as well)": "Mobil cihazınızda Yetkilendirme İsteğini Kabul Edin (Her zaman Onay Kutusunu da İşaretleyin)",
        "Wait time between toggling airplan mode (seconds)": "Uçak modu geçişleri arasındaki bekleme süresi (saniye)",
        "Turn Off Your WiFi and Turn On USB Tethering": "WiFi'yi Kapatın ve USB Tethering'i Açın",
        "Ensure your phone screen stays active while using the application.":"Uygulamayı kullanırken telefon ekranınızın aktif kalmasını sağlayın.",
        "Your Device model is {{deviceName}} with android version {{version}} and not rooted": "Cihaz modeliniz {{deviceName}}, Android sürümü {{version}} ve root yapılmamıştır",
        "Are you sure you want to deactivate the bot on this device? This will not remove the device from activated devices list.": "Bu cihazdaki bot'u devre dışı bırakmak istediğinizden emin misiniz? Bu, cihazı etkinleştirilmiş cihazlar listesinden kaldırmaz.",
        "No": "Hayır",
        "Yes": "Evet",
        "Enter your license key or purchase code.": "Lisans anahtarınızı veya satın alma kodunuzu girin.",
        "Verify": "Doğrula",
        "Actions to Perform on the Maps Listing":"Harita Listesinde Yapılacak İşlemler"      
    }
}

export default tr;
